// extracted by mini-css-extract-plugin
export default {"mainContainer":"EditInfo_mainContainer__cveVv","container":"EditInfo_container__NGwE4","row":"EditInfo_row__8YwtW"};